import { Menu } from '@headlessui/react';
import { PropsWithChildren, useEffect } from 'react';
import { FiLogOut, FiMoreVertical } from 'react-icons/fi';

import { Container, NavBar } from '@/components';
import useAuth from '@/hooks/useAuth';
import { usePermutive } from '@/hooks/usePermutive';
import { letterGenderById } from '@/utils';
import { SECTION_NAME_FOR_ADS } from '@/utils/ads';

type Props = PropsWithChildren<{
  title: string;
  subtitle: string;
}>;

const Layout = ({ children, title, subtitle }: Props) => {
  const { logout, userInitialData } = useAuth();

  const { trackPageView, isReady: isPermutiveReady } = usePermutive();

  useEffect(() => {
    // Permutive esta cargado
    if (isPermutiveReady) {
      trackPageView({
        section: SECTION_NAME_FOR_ADS.armadoMiEquipo,
        kw_premium: userInitialData?.premium,
        kw_edad: userInitialData?.edad_dt,
        kw_sexo: letterGenderById(userInitialData?.idSexo),
        kw_equipo: userInitialData?.club_hincha,
        kw_fecha: userInitialData?.fechaActiva.orden,
        kw_pines: userInitialData?.pinesDisponibles,
        kw_saldo: userInitialData?.saldo,
        kw_puntosporfecha: userInitialData?.puntos_fecha,
        kw_puntosportorneo: userInitialData?.puntos_general,
        kw_posicionporfecha: userInitialData?.posicion_fecha,
        kw_posicionportorneo: userInitialData?.posicion_general,
        kw_recibirinfo: userInitialData?.recibeInformacion,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPermutiveReady]);

  return (
    <>
      <NavBar
        mobile={{
          leftContent: {
            displayLogo: true,
          },
          centerContent: {
            title,
            subTitle: subtitle,
          },
          rightContent: {
            customRightContent: (
              <Menu>
                <Menu.Button className="rounded-[.63rem] bg-gdt-gray-9 w-8 h-8 flex justify-center items-center">
                  <FiMoreVertical className="text-white w-5 h-5" />
                </Menu.Button>
                <Menu.Items className="absolute top-[110%] w-[11.75rem] flex flex-col right-0 z-[1] bg-white shadow-lg origin-top-right rounded-md">
                  <Menu.Item>
                    <button
                      className="w-full flex gap-2 items-center pl-[1.56rem] pr-[1.56rem] h-[3.5rem]"
                      type="button"
                      onClick={() => {
                        logout();
                      }}
                    >
                      <div>
                        <FiLogOut className="w-4 h-4 text-gdt-blue" />
                      </div>
                      <span className="text-sm font-medium">Cerrar sesión</span>
                    </button>
                  </Menu.Item>
                </Menu.Items>
              </Menu>
            ),
          },
        }}
      >
        <Container className="flex relative !min-h-full" variant="fluid">
          {children}
        </Container>
      </NavBar>
    </>
  );
};

export default Layout;
